const parseNum = (raw: string) => {
    let r = raw.trim().replace(/\s/g, '');
    const hasK = /k$/i.test(r);
    const hasM = /m$/i.test(r);
    if (hasK) r = r.slice(0, -1);
    if (hasM) r = r.slice(0, -1);
    r = r.replace(/\./g, '').replace(',', '.');
    let n = parseFloat(r);
    if (isNaN(n)) return NaN;
    if (hasK) n *= 1000;
    if (hasM) n *= 1000000;
    return n;
};

export function parseRangeFilter(input: string): ((val: number) => boolean) | null {
    const s = input.trim();
    if (!s) return null;
    if (s.includes(':')) {
        const [left, right] = s.split(':');
        const min = left.trim() ? parseNum(left) : -Infinity;
        const max = right.trim() ? parseNum(right) : Infinity;
        if (isNaN(min) || isNaN(max)) return null;
        return (v) => v >= min && v <= max;
    }
    const opMatch = s.match(/^(>=|<=|>|<)(.+)$/);
    if (opMatch) {
        const n = parseNum(opMatch[2]);
        if (isNaN(n)) return null;
        switch (opMatch[1]) {
            case '>=': return (v) => v >= n;
            case '<=': return (v) => v <= n;
            case '>': return (v) => v > n;
            case '<': return (v) => v < n;
        }
    }
    const n = parseNum(s);
    if (isNaN(n)) return null;
    return (v) => Math.abs(v - n) < 0.01;
}
